import React from "react";
import { PropertyPanelSection } from "@showitinc/showit-wc";

/**
 * Wraps the showit-ui PropertyPanelSection component and forwards all props.
 * @param {Object} props
 * @param {boolean} props.open
 * @param {React.ReactElement} props.children
 * @param {string=} props.title
 * @param {() => void} props.onSIPanelToggle
 * @returns {React.ReactElement}
 */
const PropertyPanelSectionWrapper = (props) => {
  return (
    <PropertyPanelSection {...props}>{props?.open ? props.children : null}</PropertyPanelSection>
  );
};
export default PropertyPanelSectionWrapper;
